import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
const baseUrl='installation/';

@Injectable({
  providedIn: 'root'
})
export class InstallationService {

  constructor(private HttpService: HttpService) { }

  getTokenVersion() {
    return this.HttpService.get(baseUrl+'read/token_version');
  }
}
